module.exports = __webpack_public_path__ + "static/media/paypal.f3e24db2.svg";